import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/Footer";

const SECTIONS = [
  {
    title: "1. Introduction",
    body: (
      <>
        AKR Steel Detailing Services LLC (&ldquo;AKR Steel Detailing,&rdquo;
        &ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) is dedicated
        to providing robust structural foundations for modern urban landscapes.
        Specializing in structural and miscellaneous steel detailing, our team
        of engineers delivers precise fabrication plans with near 99% accuracy,
        ensuring the longevity and resilience of contemporary buildings. This
        Privacy Policy explains how we collect, use, disclose and protect your
        personal data when you visit our website or engage our services.
      </>
    ),
  },
  {
    title: "2. Scope of Services",
    body: (
      <>
        AKR Steel Detailing provides comprehensive structural and miscellaneous
        steel detailing services, including connection design, engineering,
        stamping, estimation, and material take-off. Our team of 45 engineers
        operates across two countries, serving six global clients. With the
        capacity to detail 4,000 tons of steel per month, we have successfully
        completed 850 projects.
        <span className="block mt-4">
          We will not share your opt-in to an SMS campaign with any third party
          for purposes unrelated to providing you with the services of that
          campaign. We may share your Personal Data, including your SMS opt-in
          or consent status, with third parties that help us provide our
          messaging services, including but not limited to platform providers,
          phone companies, and any other vendors who assist us in the delivery
          of text messages.
        </span>
      </>
    ),
  },
  {
    title: "3. Types of Personal Data We Collect",
    body: (
      <>
        <span className="font-semibold text-slate-900">
          Contact Information:
        </span>{" "}
        Name, email address, phone number, mailing address, company name, and
        project documents you choose to share with us (such as PDF drawings or
        bid sets).
        <span className="block mt-3">
          <span className="font-semibold text-slate-900">Usage Data:</span>{" "}
          Information on how you interact with our website, including IP
          address, browser type, device type, and pages visited.
        </span>
      </>
    ),
  },
  {
    title: "4. How We Collect Personal Data",
    body: (
      <>
        We collect personal data through various means, including:
        <ul className="list-disc pl-5 mt-3 space-y-1.5">
          <li>Online forms on our website</li>
          <li>Phone and email communications with clients</li>
          <li>In-person interactions and meetings with clients</li>
        </ul>
      </>
    ),
  },
  {
    title: "5. How We Use Personal Data",
    body: (
      <>
        <span className="font-semibold text-slate-900">
          Communication and Support:
        </span>
        <ul className="list-disc pl-5 mt-2 mb-4 space-y-1.5">
          <li>
            Respond to inquiries, requests, or feedback submitted through our
            website or other communication channels.
          </li>
          <li>
            Provide updates on projects, products, and services relevant to
            your needs.
          </li>
        </ul>
        <span className="font-semibold text-slate-900">
          Business Development:
        </span>
        <ul className="list-disc pl-5 mt-2 mb-4 space-y-1.5">
          <li>
            Tailor our offerings to align with client-specific requirements and
            industry demands.
          </li>
          <li>
            Share details about promotions, new services, or events that may
            benefit our clients.
          </li>
        </ul>
        <span className="font-semibold text-slate-900">
          Operational Efficiency:
        </span>
        <ul className="list-disc pl-5 mt-2 space-y-1.5">
          <li>
            Analyze interactions with our website to optimize user experience
            and improve navigation.
          </li>
          <li>
            Ensure the seamless delivery of services, from consultation to
            project completion.
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "6. How We Disclose Personal Data",
    body: (
      <>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>To government authorities, as required by law or regulation.</li>
        </ul>
        <span className="block mt-3">
          No mobile information will be sold or shared with third parties for
          promotional or marketing purposes.
        </span>
      </>
    ),
  },
  {
    title: "7. Security Measures",
    body: (
      <>
        We implement appropriate technical and organizational measures to
        ensure the security of personal data. These measures include:
        <ul className="list-disc pl-5 mt-3 space-y-1.5">
          <li>Encryption of sensitive data (e.g., payment information)</li>
          <li>Secure servers and databases</li>
          <li>
            Limited access to personal data based on the need-to-know principle
          </li>
          <li>Regular backups and disaster recovery procedures</li>
        </ul>
      </>
    ),
  },
  {
    title: "8. Data Retention",
    body: (
      <>
        We retain personal data for as long as necessary to fulfill our
        business purposes or as required by law or regulation. We will delete
        or anonymize personal data when it is no longer needed.
      </>
    ),
  },
  {
    title: "9. Your Rights",
    body: (
      <>
        Individuals have the right to:
        <ul className="list-disc pl-5 mt-3 space-y-1.5">
          <li>Request correction or erasure of their personal data</li>
          <li>Object to processing of their personal data for specific purposes</li>
          <li>Lodge a complaint with a supervisory authority</li>
        </ul>
      </>
    ),
  },
  {
    title: "10. Changes to This Privacy Policy",
    body: (
      <>
        We reserve the right to update this privacy policy at any time. Changes
        will be effective immediately upon posting on our website. Your
        continued use of our services constitutes acceptance of the updated
        privacy policy.
      </>
    ),
  },
  {
    title: "11. Contact Us",
    body: (
      <>
        If you have any questions or concerns about this privacy policy or
        would like to exercise your rights as an individual, please contact us
        at:
        <span className="block mt-4 font-semibold text-slate-900">
          AKR Steel Detailing Services LLC
        </span>
        3200 Wilcrest Drive, Suite 170
        <br />
        Houston, Texas 77042, United States
        <br />
        <span className="block mt-3">
          Hours: 7:00 AM to 7:00 PM CT
          <br />
          Phone:{" "}
          <a
            href="tel:+18062981003"
            className="text-[#0A2540] font-semibold hover:underline"
          >
            +1 (806) 298-1003
          </a>
          <br />
          Email:{" "}
          <a
            href="mailto:alex@akrsteel.com"
            className="text-[#0A2540] font-semibold hover:underline"
          >
            alex@akrsteel.com
          </a>
        </span>
        <span className="block mt-4">
          We are committed to protecting your privacy and ensuring that your
          personal data is handled in accordance with applicable laws and
          regulations. We don&apos;t share any information with any third-party
          entities.
        </span>
      </>
    ),
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-slate-50/60">
      <Navbar onContactClick={() => {}} />

      <main className="relative pt-28 md:pt-32 pb-20">
        <div className="absolute inset-0 grid-backdrop opacity-40 pointer-events-none" />

        <div className="relative px-6 md:px-10 lg:px-14 xl:px-16">
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.22em] text-slate-500 hover:text-[#0A2540] transition-colors mb-8"
          >
            <ArrowLeft className="w-3.5 h-3.5" strokeWidth={2.5} />
            Back to home
          </Link>

          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 mb-6 text-xs font-mono uppercase tracking-[0.22em] text-slate-500">
              <span className="w-8 h-px bg-[#0A2540]" />
              Legal · Privacy
            </div>
            <h1 className="font-display text-4xl md:text-5xl font-semibold text-[#0A2540] tracking-tight leading-[1.05]">
              Privacy Policy
            </h1>
            <p className="mt-6 text-base md:text-lg text-slate-600 leading-relaxed">
              This policy describes how AKR Steel Detailing Services LLC
              collects, uses, discloses and protects your information when you
              use our website or submit a project inquiry.
            </p>
            <div className="mt-3 text-xs font-mono uppercase tracking-[0.22em] text-slate-400">
              Effective date: January 1, 2026
            </div>

            <div className="mt-12 space-y-10">
              {SECTIONS.map((s) => (
                <section key={s.title}>
                  <h2 className="font-display text-xl md:text-2xl font-semibold text-[#0A2540] mb-3">
                    {s.title}
                  </h2>
                  <div className="text-slate-700 leading-relaxed">{s.body}</div>
                </section>
              ))}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
